import { render, staticRenderFns } from "./Modal-receive-boxFront.vue?vue&type=template&id=a0e6273e&scoped=true"
import script from "./Modal-receive-boxFront.vue?vue&type=script&lang=js"
export * from "./Modal-receive-boxFront.vue?vue&type=script&lang=js"
import style0 from "./Modal-receive-boxFront.vue?vue&type=style&index=0&id=a0e6273e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e6273e",
  null
  
)

export default component.exports